import React from "react";
import { Space, Button, Tag, message } from "antd";
import { CrownOutlined, EyeOutlined } from "@ant-design/icons";
import { COLORS, DirectoryItem } from "../types/types";

interface HeaderActionsProps {
  currentUser: DirectoryItem | null;
  hideDirectoryButton: boolean;
  onDirectoryVisibility: () => void;
  onOpenPremium: (profession: string) => void;
}

const HeaderActions: React.FC<HeaderActionsProps> = ({
  currentUser,
  hideDirectoryButton,
  onDirectoryVisibility,
  onOpenPremium,
}) => {
  if (!currentUser) {
    return (
      <Button
        onClick={() => message.info("Connectez-vous pour devenir premium")}
        style={{ color: COLORS.secondary, borderColor: COLORS.secondary }}
      >
        <CrownOutlined /> Devenir Premium
      </Button>
    );
  }

  if (currentUser.is_premium_directory) {
    return (
      <Tag color={COLORS.secondary} style={{ padding: "4px 12px" }}>
        <CrownOutlined /> Premium #{currentUser.premium_position}
      </Tag>
    );
  }

  return (
    <Space>
      {!hideDirectoryButton && (
        <Button
          onClick={onDirectoryVisibility}
          style={{ borderColor: COLORS.primary, color: "white" }}
        >
          <EyeOutlined style={{ color: "white" }} /> M&apos;apparaître
        </Button>
      )}
      
      <Button
        onClick={() => {
          if (currentUser?.show_in_directory) {
            onOpenPremium(currentUser?.profession ?? '');
          } else {
            message.info("Vous devez être visible dans l'annuaire pour devenir premium");
          }
        }}
        style={{
          backgroundColor: COLORS.secondary,
          borderColor: COLORS.secondary,
          color: "white",
          opacity: currentUser?.show_in_directory ? 1 : 0.5
        }}
        disabled={!currentUser?.show_in_directory}
      >
        <CrownOutlined /> Devenir Premium
      </Button>
    </Space>
  );
};

export default HeaderActions;